import axios from 'axios'
import { Notify, Loading } from 'quasar'
export default ({ Vue, store, router }) => {
    let mode = 3; // PRODUÇÃO: 0 | TESTE: 1 | LOCAL DEV: 2 | RAFAEL: 3
    Vue.prototype.$urlAPI = mode === 1 ? 'https://api.sistema-teste.unclik.com.br' :
        mode === 2 ? 'http://localhost:8090' :
            mode === 3 ? 'https://api.unclikhub.com.br' :
                'https://api.sistema.unclik.com.br';
    let spinnerLoading = 1;
    const client = axios.create()
    const authInterceptor = (config) => {

        var token = store.getters['customer/getToken']

        config.headers['Authorization'] = `Bearer ${token}`
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        config.baseURL = mode === 1 ? 'https://api.sistema-teste.unclik.com.br' :
            mode === 2 ? 'http://localhost:8090' :
                mode === 3 ? 'https://api.unclikhub.com.br' :
                    'https://api.sistema.unclik.com.br';
        // console.log(config)

        if (typeof config.loading === 'undefined') {
            if (typeof config.spinnerLoading !== 'undefined') {
                spinnerLoading = config.spinnerLoading
            }
        }
        else {
            spinnerLoading = config.loading
        }
        if (spinnerLoading === 1) {
            Loading.show({ message: 'Carregando...' })
        }
        return config
    }

    client.interceptors.request.use(authInterceptor, () => {
        spinnerLoading || Loading.hide()
    })

    // interceptor to catch errors
    const errorInterceptor = error => {
        // all the error responses
        if (typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined') {
            switch (error.response.status) {
                case 404:
                    break
                case 400:
                    // console.error(error.response.status, error.message)
                    break
                case 422:
                    // console.error(error.response.status, error.message)
                    // notify.warn('Nothing to display','Data Not Found')
                    break
                case 401: // authentication error, logout the user
                    // notify.warn( 'Please login again', 'Session Expired')
                    // localStorage.removeItem('token')
                    store.commit('customer/limparCustomer')
                    if ((router.currentRoute.path).indexOf('/') != -1)
                        router.push('/login')
                    else
                        router.push('/')

                    break
                default:
                    Notify.create(
                        {
                            color: 'negative',
                            caption: 'Status: ' + error.response.status,
                            message: error.response.data.message
                        })
                // notify.error('Server Error')
            }
        }
        if (spinnerLoading === 1) {
            Loading.hide()
        }
        return Promise.reject(error)
    }

    // Interceptor for responses
    const responseInterceptor = response => {
        switch (response.status) {
            case 200:
                // yay!
                break
            // any other cases
            default:
            // default case
        }
        if (spinnerLoading === 1) {
            Loading.hide()
        }
        return response
    }

    client.interceptors.response.use(responseInterceptor, errorInterceptor)

    Vue.prototype.$axios = client
    Vue.prototype.$httpGet = axios.create()
}
